import { useStore } from '@/store'
export function usePermission(pageName: string, hanldeName: string) {
  const store = useStore()
  const verifyPermission = `system:${pageName}:${hanldeName}`
  const permissions = store.state.login.permissions
  // name = "coderwhy"
  // !name -> false
  // !!name -> true
  return !!permissions.find((item: string) => item === verifyPermission)
}
